import { render, staticRenderFns } from "./ThankYouEdit.vue?vue&type=template&id=27f87e89&scoped=true"
import script from "./ThankYouEdit.vue?vue&type=script&lang=js"
export * from "./ThankYouEdit.vue?vue&type=script&lang=js"
import style0 from "./ThankYouEdit.vue?vue&type=style&index=0&id=27f87e89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f87e89",
  null
  
)

export default component.exports